/* eslint-disable consistent-return */
import { useCallback, useEffect, useRef } from 'react';

const useTimeout = (callback: any, delay: number) => {
  const savedCallback = useRef(callback);

  const memoizedCallback = useCallback(() => {
    savedCallback.current = callback;
    return savedCallback;
  }, [callback]);

  // Set up the timeout
  useEffect(() => {
    // Don't schedule if no delay is specified
    if (delay === null) return;

    const id = setTimeout(() => memoizedCallback().current(), delay);

    return () => clearTimeout(id);
  }, [delay]);
};

export default useTimeout;
